
import { useState } from "react";
import { useAuth } from "@/hooks/useAuth";
import { supabase } from "@/integrations/supabase/client";
import { toast } from "@/hooks/use-toast";

export const useBuzzzActions = () => {
  const { user } = useAuth();
  const [isLoading, setIsLoading] = useState(false);

  const sendBuzzz = async (targetUserId: string) => {
    if (!user || isLoading) return;

    setIsLoading(true);
    try {
      // Check if buzzz already sent today
      const { data: existingBuzzz, error: checkError } = await supabase
        .from('interactions')
        .select('id')
        .eq('user_id', user.id)
        .eq('target_user_id', targetUserId)
        .eq('interaction_type', 'buzzz')
        .gte('created_at', new Date(new Date().setHours(0, 0, 0, 0)).toISOString())
        .maybeSingle();

      if (checkError) throw checkError;

      if (existingBuzzz) {
        toast({
          title: "Already sent!",
          description: "You can only send one buzzz per day to each user",
          variant: "default"
        });
        return;
      }

      // Send buzzz
      const { error } = await supabase
        .from('interactions')
        .insert({
          user_id: user.id,
          target_user_id: targetUserId,
          interaction_type: 'buzzz'
        });

      if (error) throw error;

      toast({
        title: "Buzzz sent! ⚡",
        description: "Your buzzz has been delivered",
      });

    } catch (error: any) {
      console.error('Error sending buzzz:', error);
      toast({
        title: "Error",
        description: "Failed to send buzzz. Please try again.",
        variant: "destructive"
      });
    } finally {
      setIsLoading(false);
    }
  };

  return {
    sendBuzzz,
    isLoading
  };
};
